import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { HorizontalBar } from 'react-chartjs-2';
import { withStyles } from '@material-ui/styles';
import H6 from 'components/base/titles/CardHeading/H6';
import LabelWithInfoIcon from 'components/base/LabelWithInfoIcon/LabelWithInfoIcon';
import withAll from 'components/base/withAll';
import { FOLLOWER_RANGE_COLORS, FOLLOWER_RANGE_LABELS } from 'components/common/CompetitiveReport/constants';
import { formatNumber } from 'utils/helpers';

const styles = () => ({
  root: {},
});

const ByFollowerRangeHorizontal = ({ classes, data }) => {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      animateScale: true,
      animateRotate: true,
    },
    tooltips: {
      enabled: true,
      displayColors: false,
      intersect: false,
      mode: 'index',
      callbacks: {
        label: (tooltip, dataset) => {
          const { datasetIndex } = tooltip;
          // Only show for the main dataset. The other dataset is just for visual effect.
          if (datasetIndex !== 0) {
            return '';
          }
          return dataset.datasets.map(d => (
            `${d.label}: ${formatNumber(d.data[tooltip.index], '0.00a', '-')}`
          ));
        },
      },
    },
    legend: {
      display: true,
      position: 'bottom',
      labels: {
        boxWidth: 12,
        usePointStyle: true,
      },
    },
    scales: {
      yAxes: [{
        display: true,
        stacked: true,
        gridLines: {
          display: true,
          drawOnChartArea: false,
        },
      }],
      xAxes: [{
        display: true,
        stacked: true,
        gridLines: {
          display: true,
          drawOnChartArea: true,
        },
        ticks: {
          callback: value => formatNumber(value, '0a', '0'),
        },
      }],
    },
    plugins: {
      datalabels: {
        display: false,
      },
    },
  };

  const labels = data.map(b => b.name);
  const chartData = {
    labels,
    datasets: Object.keys(FOLLOWER_RANGE_LABELS).map(followerRange => ({
      label: FOLLOWER_RANGE_LABELS[followerRange],
      data: data.map(b => b.currentPeriod[followerRange]),
      backgroundColor: FOLLOWER_RANGE_COLORS[followerRange],
      barThickness: 30,
    })),
  };

  const chartHeight = Math.max(200, 100 * data.length);

  return (
    <div className={classes.root}>
      <H6>
        <LabelWithInfoIcon
          labelText="Estimated Share of Spend by Company"
          tooltip="Brand's Individual Spend, segmented by Creator size."
        />
      </H6>
      <HorizontalBar
        data={chartData}
        options={options}
        height={chartHeight}
        redraw
      />
    </div>
  );
};

ByFollowerRangeHorizontal.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    logo: PropTypes.string,
    currentPeriod: PropTypes.shape({}),
  })),
};

ByFollowerRangeHorizontal.defaultProps = {
  data: [],
};

const mapStateToProps = ({ competitiveReportEstimatedSpend: { data: { data } } }) => ({
  data,
});

export default withAll(
  connect(mapStateToProps, null),
  withStyles(styles),
)(ByFollowerRangeHorizontal);
